import React, { useState } from "react";
import moment from "moment";
import { FaUsers } from "react-icons/fa";
import { shallowEqual, useSelector } from "react-redux";
import { Loader } from "../../../components/loader";
import { AppListing } from "../../../components/AppListing/Listing.view";
import MainPageDialog from "../../../components/dialog";
import {
  useGetTriageNotesQuery,
  useTasksMetaQuery,
} from "../../../services/triageServices";
import { useForm } from "react-hook-form";
import { DatePickerFeild } from "../../../components/reactHookFormFields/datePicker";
import { formattedDate } from "../../../helper";
import { ReactSelectField } from "../../../components/reactHookFormFields/selectField";
import { mergeArraysByKey } from "../../ShareData/helper";

function AttachTriageNotes({
  addTriageNotesDialog,
  setAddTriageNotesDialog,
  shareDataDetail,
  selectedChat,
}) {
  let defaultObj = {
    note_added_by: "",
    note_added_from: "",
    note_added_to: "",
    note_resolved_by: "",
    priority: "",
    triage_status: "all",
    users: [],
  };
  const [payload, setPayload] = useState({ ...defaultObj });
  const { data: taskAndAlertsSettings } = useTasksMetaQuery();
  const { data, isFetching: isLoading } = useGetTriageNotesQuery({
    ...payload,
    pid: selectedChat?.pid,
    page: 1,
  });
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();
  const closeHandler = () => {
    if (shareDataDetail) {
      shareDataDetail?.closeDialog();
    } else {
      setAddTriageNotesDialog(false);
    }
  };

  const cols = [
    {
      title: "Created By",
      key: "updated",
      colWidth: "2",
      getData: (item) => {
        return (
          <p>
            {item?.created_by_name} <br />
            <span>{moment(item?.created).format("MM/DD/YYYY hh:mm A")}</span>
          </p>
        );
      },
    },
    {
      title: "Note",
      colWidth: "1",
      getData: (item) => {
        return (
          <p>
            <span title={item?.notes}>
              {item?.notes?.length > 80
                ? item?.notes?.slice(0, 80) + "..."
                : item?.notes}
            </span>
          </p>
        );
      },
    },
    {
      title: "Disposition",
      key: "disposition",
      colWidth: "1",
      getData: (item) => {
        console.log(item, "item");
        return <p>{item?.disposition ? item?.disposition : "-"}</p>;
      },
    },
    {
      title: "Assigned To",
      key: "title",
      colWidth: "2",
      getData: (item) => {
        console.log(item, "item");
        return (
          <>
            {item?.selected_users?.map((sUser) => (
              <div
                className={`${
                  sUser?.user_array?.length > 0
                    ? " border border-gray-300 rounded-md p-1.5 hover:bg-gray-100"
                    : ""
                } mt-0.5 flex gap-2`}
              >
                {sUser?.user_array?.length > 0 && (
                  <>
                    <span>({sUser?.user_array?.length})</span>{" "}
                    <FaUsers className="text-gray-500 max-w-5 max-h-5 min-h-4 min-w-4" />
                  </>
                )}{" "}
                {sUser?.name}
              </div>
            ))}
          </>
        );
      },
    },
    {
      title: "Updated By",
      colWidth: "2",
      getData: (item) => {
        return (
          <p>
            {item?.created_by_name} <br />
            {moment(item?.updated).format("MM/DD/YYYY hh:mm A")}
          </p>
        );
      },
    },
    {
      title: "Resolved By",
      key: "",
      colWidth: "2",
    },
    {
      title: "Priority",
      colWidth: "1",
      getData: (item) => {
        if (item?.priority)
          return (
            <p
              className={` ${
                item?.priority?.toLowerCase() == "medium"
                  ? "bg-amber-500"
                  : "bg-red-400"
              }  text-white rounded-md text-center capitalize`}
            >
              {item?.priority}
            </p>
          );
      },
    },
    {
      title: "Status",
      colWidth: "1",
      getData: (item) => {
        if (item?.user_task_status)
          return (
            <div className="w-full">
              <p
                className={`  capitalize ${
                  item?.user_task_status?.toLowerCase() == "resolved"
                    ? "bg-green-600"
                    : "bg-amber-500"
                }  text-white rounded-md text-center `}
              >
                {item?.user_task_status}
              </p>
            </div>
          );
      },
    },
  ];

  const submitHandler = (data) => {
    let payload = {
      note_added_by: data?.note_added_by?.id,
      note_added_from:
        data?.note_added_from && formattedDate(data?.note_added_from),
      note_added_to: data?.note_added_to && formattedDate(data?.note_added_to),
      note_resolved_by: data?.note_resolved_by?.id,
      priority: data?.priority?.slug,
      triage_status: data?.triage_status?.map((v, k) => v?.slug)?.join(","),
      users: data?.users?.map((v, k) => v?.id)?.join(","),
    };
    setPayload(payload);
  };
  const resetHandler = () => {
    Object.entries(defaultObj).forEach(([name, value]) =>
      setValue(name, value)
    );
    setPayload(defaultObj);
  };
  const footerList = [
    {
      type: "save",
      action: () => {
        shareDataDetail?.attachHandler(shareDataDetail?.selectedFiles);
      },
      title: "Attach",
    },
    {
      type: "cancel",
      action: () => closeHandler(),
      title: "Cancel",
    },
  ];

  return (
    <>
      {addTriageNotesDialog && (
        <MainPageDialog
          title={`Attach Triage Notes`}
          footer={true}
          footerList={footerList}
          onCancelHandler={() => closeHandler()}
        >
          <div className="mt-5">
            {isLoading && (
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-30">
                {" "}
                <Loader />
              </div>
            )}
            <div className="grid grid-cols-2 gap-3 mb-3">
              {/* <ProviderSearch
                title="Created By"
                name="note_added_by"
                control={control}
                errors={errors}
              /> */}
              <ReactSelectField
                title="Assigned To"
                name="users"
                isMulti={true}
                control={control}
                errors={errors}
                options={taskAndAlertsSettings?.provider_list?.map((v) => {
                  return { ...v, label: v?.name };
                })}
              />
              <ReactSelectField
                isMulti={true}
                title="Status"
                name="triage_status"
                control={control}
                errors={errors}
                options={[
                  { label: "Pending", slug: "pending" },
                  { label: "Resolved", slug: "resolved" },
                  { label: "Partially Resolved", slug: "partially_resolved" },
                ]}
              />
            </div>
            <div className="grid grid-cols-5 gap-3 mb-4">
              {/* <ProviderSearch
                title="Resolved By"
                name="note_resolved_by"
                control={control}
                errors={errors}
              /> */}
              <DatePickerFeild
                name="note_added_from"
                title="Created From"
                control={control}
                dateTime={false}
              />
              <DatePickerFeild
                name="note_added_to"
                title="Created to"
                control={control}
                dateTime={false}
              />
              {/* <ReactSelectField
                control={control}
                name="priority"
                title="Priority"
                showLabel="title"
                isClearable={true}
                optionData={taskAndAlertsSettings?.priority}
              /> */}
              <div className="flex items-center">
                <button
                  className="px-3 h-full bg-bgGreen hover:bg-primary-hover text-white cursor-pointer"
                  onClick={handleSubmit(submitHandler)}
                >
                  Search
                </button>
                <button
                  className="px-3 h-full ml-2 bg-gray-200 hover:bg-gray-300 cursor-pointer"
                  onClick={() => resetHandler()}
                >
                  Reset
                </button>
              </div>
            </div>
            <AppListing
              listData={
                shareDataDetail?.selectedFiles?.length > 0
                  ? mergeArraysByKey(data, shareDataDetail?.selectedFiles)
                  : data
              }
              cols={cols}
              selection={true}
              toggleSelectItem={(data) => {
                shareDataDetail?.setSelectedFiles(data);
              }}
            />
          </div>
        </MainPageDialog>
      )}
    </>
  );
}

export default AttachTriageNotes;
